import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { MobileNav } from '@/widgets/mobile-nav';
import { Sidebar } from '@/widgets/sidebar';
import { InferenceNotifications } from '@/shared/components/inference-notifications';

import { setNavigate } from '@/shared/utils/router-navigation';

export const BaseLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the navigate function globally for use outside React components
    setNavigate(navigate);
  }, [navigate]);

  return (
    <div className="h-screen bg-background text-foreground flex overflow-hidden">
      {/* Atmospheric gradient element */}
      <div className="fixed top-[-30%] right-[-20%] w-[60%] h-[60%] bg-[radial-gradient(circle,hsl(252_95%_76%/0.03),transparent_70%)] pointer-events-none z-0" />

      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden lg:block relative z-10">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden relative z-10">
        <main className="flex-1 overflow-auto pb-16 lg:pb-0">
          <Outlet />
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />

      {/* Global inference notifications */}
      <InferenceNotifications />
    </div>
  );
};
